import React from 'react';
import ActionsBlock from './ActionsBlock';
import * as CurrencyUtils from '../../../../../../utils/currency';

export const TableColumns = (mode: 'VIEW' | 'EDIT') => [
  {
    label: '#',
    id: 'vat_correction_id',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Return ID',
    id: 'vat_return_id',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Period',
    id: 'period',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Year',
    id: 'year',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Consumer MS',
    id: 'country',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Correction Amount',
    id: 'amount',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => <ActionsBlock rowIndex={rowIndex} mode={mode} />,
    inData: false,
  },
];
